import { render, staticRenderFns } from "./TableBasic.vue?vue&type=template&id=220927ea"
import script from "./TableBasic.vue?vue&type=script&lang=js"
export * from "./TableBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports